import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import { useSelector } from "react-redux";
//styles
import styles from "./OrgOverviewStyles.module.scss";
//mui
import { Grid2 } from "@mui/material";
//icons
import { ReactComponent as Orgpic } from "../../../../AdminAssets/svg/parentOrg.svg";
import { ReactComponent as PersonalIcon } from "../../../../../../GlobalAssets/svg/personalIcon.svg";
import { ReactComponent as ClientIcon } from "../../../../../../GlobalAssets/svg/clientIcon.svg";
import { ReactComponent as ParentIcon } from "../../../../../../GlobalAssets/svg/parentIcon.svg";
//local imports
import PageHeader from "../../../../../../GlobalComponents/PageHeader/PageHeader";
import OrganizationInvitation from "../Invitations/OrganizationInvitation";
import PersonalSpace from "../../Components/PersonalSpace/PersonalSpace";
import OrganizationSpace from "../../Components/OrganizationSpace/OrganizationSpace";
import OrgOverviewPageLoading from "../../../../../../GlobalComponents/OrgOverviewPageLoading/OrgOverviewPageLoading";
import WelcomeOverview from "../../../../../../GlobalComponents/WelcomeOverview/WelcomeOverview";
import NewPopup from "../../../../../../GlobalComponents/Popup/NewPopup";
import Dropdown from "../../../../../../GlobalComponents/Dropdown/Dropdown";
import NoData from "../../../../../../GlobalComponents/NoData/NoData";
import { clearData } from "../../../../../../Utils/clearData";
import { isWhiteLabelDomain } from "../../../../../../Utils/roconConstants";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import { blockIfOrgDeleting } from "../../../../../../Utils/activatePopup";

// trigger test disabled test

function OrganizationOverview({ searchValue }) {
  const navigate = useNavigate();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [lastAppliedValues, setLastAppliedValues] = useState([]); // New state for last applied filter values
  const [filterApplied, setFilterApplied] = useState(false);
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [searchedOrganizations, setSearchedOrganization] = useState("");
  const [hasPlanCheck, setHasPlanCheck] = useState(false);

  const userRoleOptions = [
    { label: "Owner", value: "Owner" },
    { label: "Super Admin", value: "SuperAdmin" },
    { label: "Admin", value: "Admin" },
    { label: "User", value: "User" },
  ];

  useEffect(() => {
    getStore().dispatch({ type: Actions.API_ORG_DASHBOARD });
    getStore().dispatch({ type: Actions.API_ORG_USER_INVITATIONS });
    getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
    getStore().dispatch({ type: Actions.API_USER_DETAILS });
    getStore().dispatch({
      type: Actions.API_GET_SEPCIFIC_PLAN,
      data: { orgId: -1 },
    });
    getStore().dispatch({ type: Actions.API_CHECK_USER_HAS_PLAN });
  }, []);

  useEffect(() => {
    if (hasPlanCheck) {
      setHasPlanCheck(false);
      navigate("/account/buy-plan");
    }
  }, [hasPlanCheck]);

  const organizationsInfo = useSelector((state) => state.organizationsInfo);
  const orgData = organizationsInfo?.dashboardOrg?.data || [];
  const invitationsData = useSelector(
    (state) => state.users?.userInvitations?.data || [],
  );
  const hasPlanData = useSelector((state) => state?.users?.hasPlan);
  const rawOrgData = useSelector(
    (state) => state?.organizationsInfo?.dashboardOrg,
  );
  const rawInvitationsData = useSelector(
    (state) => state?.users?.userInvitations,
  );
  const initialCheckDone = useRef(false);

  useEffect(() => {
    if (initialCheckDone.current) return;
    // Wait until all 3 APIs have actually returned (not just defaulted to [])
    if (hasPlanData === undefined || hasPlanData === null) return;
    if (rawOrgData === undefined || rawOrgData === null) return;
    if (rawInvitationsData === undefined || rawInvitationsData === null) return;

    initialCheckDone.current = true;

    const hasOrgs = rawOrgData?.data?.length > 0;
    const hasInvitations = rawInvitationsData?.data?.length > 0;
    const hasOrgPlan = rawOrgData?.data?.some((org) => org.planName);

    // Not on a white-label domain: its Buy Plan page sends everyone straight back here, so the
    // two pages would bounce for ever, re-firing this page's API calls on every pass.
    if (
      !isWhiteLabelDomain() &&
      !hasPlanData?.hasPlan &&
      hasPlanData !== true &&
      !hasInvitations &&
      !hasOrgs
    ) {
      navigate("/account/buy-plan");
    }
  }, [hasPlanData, rawOrgData, rawInvitationsData]);
  const userDetails = useSelector((state) => state.users?.userDetails);
  const indvPlan = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans,
  );
  const basePlan = indvPlan?.find((plan) => plan.basePlan === true);

  const [cardStatus, setCardStatus] = useState({
    title: "All Organizations",
    value: "AllOrganizationsTable",
  });
  const [filteredOrganizations, setFilteredOrganizations] = useState([]);
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupCancelTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });

  const selectTab = (event, newValue) => {
    setCardStatus(newValue);
  };

  const filterOrganizations = (newValue) => {
    if (newValue.value === "ParentOrganizationsTable") {
      return orgData.filter((org) => org.parentOrgName === null);
    } else if (newValue.value === "ClientOrganizationsTable") {
      return orgData.filter((org) => org.parentOrgName !== null);
    }
    return orgData;
  };

  const updateFilteredOrganizations = () => {
    const newFilteredOrganizations = filterOrganizations(cardStatus);

    if (
      JSON.stringify(filteredOrganizations) !==
      JSON.stringify(newFilteredOrganizations)
    ) {
      setFilteredOrganizations(newFilteredOrganizations);
      setFilterApplied(false);
      setIsFilterOn(false);
      setSelectedValues([]);
      setLastAppliedValues([]); // Reset last applied values when tab changes
    }
  };

  useEffect(() => {
    updateFilteredOrganizations();
  }, [cardStatus, orgData]);

  const blueprintInfo = useSelector((state) => state.bluePrintInfo);
  const selectedSite = useSelector(
    (state) => state.sitesInfo.allSites?.siteDetailsResponses,
  );
  const selectedOrg = useSelector(
    (state) => state.organizationsInfo.dashboardOrg?.data,
  );
  const allSites = useSelector((state) => state.sitesInfo?.allSites);

  const dedicatedHosting = useSelector(
    (state) => state.plansInfo?.specificPlan?.isDedicated,
  );

  useEffect(() => {
    if (blueprintInfo?.userOrgBluePrints?.data?.length > 0) {
      getStore().dispatch({
        type: Actions.SET_GET_ALL_BLUEPRINT,
        data: {
          data: [],
        },
      });
    }
    if (selectedSite?.length > 0) {
      getStore().dispatch({
        type: Actions.SET_SELECTED_SITE_DETAILS,
        data: null,
      });
    }
    if (selectedOrg?.length > 0) {
      getStore().dispatch({
        type: Actions.SET_SELECTED_ORG,
        data: null,
      });
    }
    if (allSites) {
      getStore().dispatch({
        type: Actions.SET_ALL_SITES,
        data: null,
      });
    }
    clearData();
  }, []);

  const handlePersonalSpace = () => {
    navigate(`/account/${-1}/dashboard`, {
      state: { orgId: -1 },
    });
  };

  const invitations = Array.isArray(invitationsData)
    ? invitationsData.map((invite) => {
        const date = new Date(invite.invitedAt);

        // Format date to "21 Oct 2024"
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });

        // Format time to display hours and minutes with AM/PM
        const formattedTime = date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // to get AM/PM
        });

        return {
          icon: invite.avatarId || Orgpic,
          name: invite.orgName,
          username: invite.invitedBy,
          time: `${formattedDate}, ${formattedTime}`,
          ownername: invite.orgOwnerName,
          team: invite.noOfOrgMembers,
          sites: invite.noOfSites,
          orgId: invite.orgId,
        };
      })
    : []; // Return empty array if invitationsData is not an array

  const { userName } = userDetails || {};

  const onCreateOrganizationClick = () => {
    navigate("/account/create-organization");
  };

  const filterOrganizationsData = (searchValue) => {
    const orgs =
      filteredOrganizations?.length > 0 ? filteredOrganizations : orgData;

    if (searchValue?.trim() === "") {
      return orgs;
    } else {
      return orgs.filter((org) =>
        org.name?.toLowerCase().includes(searchValue?.toLowerCase()),
      );
    }
  };

  useEffect(() => {
    const filtered = filterOrganizationsData(searchValue);
    setSearchedOrganization(filtered);
  }, [searchValue, filteredOrganizations]);

  const handleOpenFilter = () => {
    setIsFilterOpen(true);
    setSelectedValues(lastAppliedValues); // Initialize with last applied values
  };

  const handleCloseFilter = () => {
    setIsFilterOpen(false);
    setFilterApplied(false);
    setSelectedValues(lastAppliedValues); // Revert to last applied values
  };

  const handleClearFilter = () => {
    setIsFilterOpen(false);
    setFilterApplied(false);
    setIsFilterOn(false);
    setSelectedValues([]);
    setLastAppliedValues([]); // Clear last applied values
    setFilteredOrganizations(filterOrganizations(cardStatus));
  };

  const handleSelect = (newValues) => {
    setSelectedValues(newValues);
    setFilterApplied(false);
  };

  const handleFilter = () => {
    setIsFilterOn(true);
    setFilterApplied(true);
    setLastAppliedValues(selectedValues); // Save applied values
    const filtered = () => {
      const newFilteredOrganizations = filterOrganizations(cardStatus);
      if (selectedValues && selectedValues?.length > 0) {
        const roleMapping = {
          Owner: "ORG_OWNER",
          Admin: "ORG_ADMIN",
          User: "ORG_STANDARD_USER",
          SuperAdmin: "ORG_SUPER_ADMIN",
        };

        const backendRoles = selectedValues
          .map((role) => roleMapping[role])
          .filter((role) => role);

        return newFilteredOrganizations.filter((organization) =>
          backendRoles.includes(organization.role),
        );
      }

      return newFilteredOrganizations;
    };

    setFilteredOrganizations(filtered);
    setIsFilterOpen(false);
  };

  const isDisabled =
    (selectedValues.length > 0 &&
      JSON.stringify(selectedValues) === JSON.stringify(lastAppliedValues)) ||
    selectedValues?.length === 0;

  const showOrgs =
    searchValue?.length > 0 && filteredOrganizations?.length > 0
      ? searchedOrganizations
      : filteredOrganizations
        ? filteredOrganizations
        : searchValue?.length > 0
          ? searchedOrganizations
          : orgData;

  // const handleRemoveFilter = (value) => {
  //   const newSelectedValues = selectedValues.filter((v) => v !== value);
  //   setSelectedValues(newSelectedValues);

  //   if (newSelectedValues.length === 0) {
  //     // If no filters are selected, show all organizations
  //     setFilteredOrganizations(orgData);
  //     setFilterApplied(false);
  //     setIsFilterOn(false);
  //   } else {
  //     // Reapply filters with the remaining selected values
  //     handleFilter(newSelectedValues);
  //   }
  // };

  return (
    <>
      {userDetails && orgData && indvPlan ? (
        <Grid2 className={styles.OrganizationOverview}>
          <PageHeader
            header={"Organizations"}
            subheader={
              "Get your projects up and running faster by inviting your team to collaborate."
            }
            selectedTab={cardStatus}
            setSelectedTab={selectTab}
            tabs={[
              {
                title: "All Organizations",
                value: "AllOrganizationsTable",
              },
              {
                title: "Parent Organizations",
                value: "ParentOrganizationsTable",
              },
              {
                title: "Client Organizations",
                value: "ClientOrganizationsTable",
              },
            ]}
            button={"Create Organization"}
            buttonClick={onCreateOrganizationClick}
            buttonThreeText={true}
            filterClick={handleOpenFilter}
            // selectedValues={selectedValues} // Ensure this is passed
            // onRemoveFilter={handleRemoveFilter}
          />

          <Grid2
            className={invitations?.length > 0 ? styles.invitationFlex : ""}
          >
            <Grid2 className={styles.spaceContainer}>
              <Grid2
                className={`${styles.containercard} ${
                  (showOrgs.length === 0 &&
                    invitations?.length !== 0 &&
                    styles.invitationsActiveAtNoOrgs) ||
                  (invitations.length > 0 && styles.invitationsActive)
                }`}
              >
                {!isFilterOn &&
                  searchValue?.length === 0 &&
                  cardStatus.value === "AllOrganizationsTable" && (
                    <Grid2
                      className={`${
                        showOrgs?.length === 0 &&
                        invitations?.length === 0 &&
                        styles.noInvitationOrOrgs
                      }`}
                    >
                      <PersonalSpace
                        icon={PersonalIcon}
                        name={userName}
                        plan={basePlan}
                        onClick={handlePersonalSpace}
                        userDetails={userDetails}
                        dedicatedHosting={dedicatedHosting}
                      />
                    </Grid2>
                  )}

                {showOrgs?.length > 0 &&
                  showOrgs.map((org, index) => (
                    <OrganizationSpace
                      key={index}
                      icon={
                        org.parentOrgName === null ? ParentIcon : ClientIcon
                      }
                      name={org.name}
                      sites={`${org.sitesCount || 0} Sites`}
                      team={`${org.membersCount} Members`}
                      plan={org.parentOrgName === null && org.planName}
                      orgName={org.parentOrgName !== null && org.parentOrgName}
                      onClick={() => {
                        if (blockIfOrgDeleting(org, setPopup)) {
                          return;
                        }
                        navigate(`/account/${org.orgId}/dashboard`, {
                          state: { orgId: org.orgId, isChild: org.isChild },
                        });
                      }}
                      isChild={org.parentOrgName !== null}
                      orgId={org?.orgId}
                      deletionInProgress={org?.deletionInProgress}
                      childOrgs={org.childOrgsCount}
                      imagePath={org.imagePath}
                      expiry={org.expiry}
                      country={org.country}
                      isDedicated={org.isDedicated}
                      isSingleSite={org?.planName?.startsWith("SS")}
                    />
                  ))}
              </Grid2>
              {(cardStatus.value === "ClientOrganizationsTable" ||
                cardStatus.value === "ParentOrganizationsTable") &&
              showOrgs?.length === 0 ? (
                <Grid2
                  className={`${
                    invitationsData?.length > 0 ? styles.adjustedNoData : ""
                  }`}
                >
                  <Grid2 className={styles.noData}>
                    <NoData
                      message={
                        cardStatus.value === "ClientOrganizationsTable"
                          ? "No Client Organizations Found"
                          : "No Parent Organizations Found"
                      }
                    />
                  </Grid2>
                </Grid2>
              ) : (filterApplied && filteredOrganizations?.length === 0) ||
                (searchValue?.length > 0 &&
                  searchedOrganizations?.length === 0) ? (
                <Grid2
                  className={`${
                    invitationsData?.length > 0 ? styles.adjustedNoData : ""
                  }`}
                >
                  <Grid2 className={styles.noData}>
                    <NoData
                      message={
                        filterApplied
                          ? "No Filtered Organizations Found"
                          : "No Searched Organizations Found"
                      }
                    />
                  </Grid2>
                </Grid2>
              ) : showOrgs?.length === 0 ? (
                <Grid2 className={styles.welcomeIOverview}>
                  <WelcomeOverview />
                </Grid2>
              ) : null}
            </Grid2>
            {!filterApplied &&
              searchValue?.length === 0 &&
              invitations?.length > 0 && (
                <Grid2 className={styles.invitationContainer}>
                  <OrganizationInvitation
                    invitations={invitations}
                    hasPlanCheck={hasPlanCheck}
                    setHasPlanCheck={setHasPlanCheck}
                  />
                </Grid2>
              )}
          </Grid2>
        </Grid2>
      ) : (
        <OrgOverviewPageLoading />
      )}
      <NewPopup
        trigger={isFilterOpen}
        closePopup={handleCloseFilter}
        header={"Organization Filter"}
        customWidth={"30%"}
        backPopup={"Clear"}
        backOnClick={handleClearFilter}
        nextpopup={"Apply"}
        nextOnClick={handleFilter}
        disabled={isDisabled}
      >
        <Dropdown
          placeholder="Select a Role"
          options={userRoleOptions}
          value={selectedValues}
          onSelect={handleSelect}
          multiple={true}
        />
      </NewPopup>
      <FormPopup
        trigger={popup.popupState}
        setTrigger={setPopup}
        type={popup.popupType}
        title={popup.popupTitle}
        subtitle={popup.popupSubtitle}
        button={popup.popupButton}
        cancel={popup.popupCancel}
        buttonTitle={popup.popupButtonTitle}
        buttonFunction={popup.popupButtonFunction}
        cancelTitle={popup.popupCancelTitle}
        cancelFunction={popup.popupCancelFunction}
      />
    </>
  );
}

export default OrganizationOverview;
